import styles from "./MeetTheTeamComponent.module.css";

export default function TeamMemberCard({ content }) {
  return (
    <div className={styles.team_card_container}>
      <div className={styles.team_image_wrapper}>
        <div className={styles.team_card_image}>
          <img
            className={`${styles.team_image} default`}
            src={process.env.IMAGE_LINK + content?.value}
            alt={content.title}
          />
          {content?.overLayImage && (
            <img
              className={`${styles.team_image} overlay`}
              src={process.env.IMAGE_LINK + content?.overLayImage}
              alt={content.title}
            />
          )}
        </div>
        {content !== null && (
          <div className={styles.team_card_content}>
            <h5 className={styles.team_member_name}>{content.title}</h5>
            <h6 className={styles.team_member_designation}>
              {content.subTitle}
            </h6>
            <p className={styles.team_member_para}>{content.description}</p>
          </div>
        )}
      </div>
    </div>
  );
}
